import { render } from "./SaveForLater.vue?vue&type=template&id=3441b8fe"
import script from "./SaveForLater.vue?vue&type=script&lang=js"
export * from "./SaveForLater.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__